// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

export default class MenuPartProduct extends ApiObject {

  id: string = '';

  additionalPrice: number = 0;

  baseAdditionalPrice: number = 0;

  postJsonAssignation(data: Object) {
    // TODO: postJsonAssignation
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/menu/MenuPartProduct.js